// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StructureMapVisualEditor_editor__-KCGJ {
  display: grid;
  gap: 1rem;
  max-height: 75vh;
  overflow: auto;
  padding-right: 0.4rem;
}

.StructureMapVisualEditor_validation__4SImV {
  margin: 0;
}

.StructureMapVisualEditor_validation__4SImV ul {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
}

.StructureMapVisualEditor_rootCard__KfwZh,
.StructureMapVisualEditor_groupCard__wSeKX,
.StructureMapVisualEditor_ruleCard__-HuCQ,
.StructureMapVisualEditor_lineCard__aSvFl {
  border-color: #ced9e4;
}

.StructureMapVisualEditor_rootCard__KfwZh h3,
.StructureMapVisualEditor_groupsHeader__N2YG4 h3 {
  font-size: 1.05rem;
  margin: 0;
}

.StructureMapVisualEditor_groupCard__wSeKX {
  border-left: 4px solid var(--bs-primary);
}

.StructureMapVisualEditor_ruleCard__-HuCQ {
  background: #fbfdff;
  margin-top: 0.8rem;
}

.StructureMapVisualEditor_lineCard__aSvFl {
  background: white;
  margin: 0.5rem 0;
}

.StructureMapVisualEditor_cardTitle__n7BlC,
.StructureMapVisualEditor_groupsHeader__N2YG4,
.StructureMapVisualEditor_ruleHeader__ALYeF,
.StructureMapVisualEditor_lineHeader__M2fZb,
.StructureMapVisualEditor_parameter__8DFMi,
.StructureMapVisualEditor_importLine__JbF-a {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.StructureMapVisualEditor_cardTitle__n7BlC,
.StructureMapVisualEditor_groupsHeader__N2YG4,
.StructureMapVisualEditor_ruleHeader__ALYeF,
.StructureMapVisualEditor_lineHeader__M2fZb {
  justify-content: space-between;
}

.StructureMapVisualEditor_cardTitle__n7BlC h3,
.StructureMapVisualEditor_cardTitle__n7BlC h4 {
  margin: 0;
}

.StructureMapVisualEditor_cardTitle__n7BlC h4,
.StructureMapVisualEditor_ruleHeader__ALYeF span {
  font-size: 1rem;
  font-weight: 700;
}

.StructureMapVisualEditor_field__Bgo9I {
  margin-bottom: 0.65rem;
}

.StructureMapVisualEditor_field__Bgo9I label {
  color: #435466;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
}

.StructureMapVisualEditor_sectionLabel__AbQkc {
  color: #285a87;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 1rem 0 0.35rem;
}

.StructureMapVisualEditor_compactRow__whrKx {
  align-items: end;
}

.StructureMapVisualEditor_deleteColumn__IU4d9 {
  padding-bottom: 0.65rem;
}

.StructureMapVisualEditor_parameterList__3sNiW {
  display: grid;
  gap: 0.35rem;
  margin-top: 0.5rem;
}

.StructureMapVisualEditor_parameter__8DFMi {
  align-items: end;
  border-top: 1px dashed #d9e0e8;
  padding-top: 0.45rem;
}

.StructureMapVisualEditor_parameter__8DFMi .StructureMapVisualEditor_field__Bgo9I {
  flex: 1 1;
  margin: 0;
}

.StructureMapVisualEditor_imports__\\+VGVk {
  display: grid;
  gap: 0.45rem;
  margin-top: 0.75rem;
}

.StructureMapVisualEditor_importLine__JbF-a .StructureMapVisualEditor_form-control__YJw2r {
  flex: 1 1;
}

@media (max-width: 767px) {
  .StructureMapVisualEditor_editor__-KCGJ {
    max-height: none;
  }

  .StructureMapVisualEditor_parameter__8DFMi,
  .StructureMapVisualEditor_cardTitle__n7BlC,
  .StructureMapVisualEditor_groupsHeader__N2YG4,
  .StructureMapVisualEditor_ruleHeader__ALYeF,
  .StructureMapVisualEditor_lineHeader__M2fZb {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StructureMapVisualEditor/StructureMapVisualEditor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;;;;IAKE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".editor {\n  display: grid;\n  gap: 1rem;\n  max-height: 75vh;\n  overflow: auto;\n  padding-right: 0.4rem;\n}\n\n.validation {\n  margin: 0;\n}\n\n.validation ul {\n  margin: 0.5rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.rootCard,\n.groupCard,\n.ruleCard,\n.lineCard {\n  border-color: #ced9e4;\n}\n\n.rootCard h3,\n.groupsHeader h3 {\n  font-size: 1.05rem;\n  margin: 0;\n}\n\n.groupCard {\n  border-left: 4px solid var(--bs-primary);\n}\n\n.ruleCard {\n  background: #fbfdff;\n  margin-top: 0.8rem;\n}\n\n.lineCard {\n  background: white;\n  margin: 0.5rem 0;\n}\n\n.cardTitle,\n.groupsHeader,\n.ruleHeader,\n.lineHeader,\n.parameter,\n.importLine {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.cardTitle,\n.groupsHeader,\n.ruleHeader,\n.lineHeader {\n  justify-content: space-between;\n}\n\n.cardTitle h3,\n.cardTitle h4 {\n  margin: 0;\n}\n\n.cardTitle h4,\n.ruleHeader span {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.field {\n  margin-bottom: 0.65rem;\n}\n\n.field label {\n  color: #435466;\n  font-size: 0.78rem;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n}\n\n.sectionLabel {\n  color: #285a87;\n  font-size: 0.9rem;\n  font-weight: 700;\n  margin: 1rem 0 0.35rem;\n}\n\n.compactRow {\n  align-items: end;\n}\n\n.deleteColumn {\n  padding-bottom: 0.65rem;\n}\n\n.parameterList {\n  display: grid;\n  gap: 0.35rem;\n  margin-top: 0.5rem;\n}\n\n.parameter {\n  align-items: end;\n  border-top: 1px dashed #d9e0e8;\n  padding-top: 0.45rem;\n}\n\n.parameter .field {\n  flex: 1;\n  margin: 0;\n}\n\n.imports {\n  display: grid;\n  gap: 0.45rem;\n  margin-top: 0.75rem;\n}\n\n.importLine .form-control {\n  flex: 1;\n}\n\n@media (max-width: 767px) {\n  .editor {\n    max-height: none;\n  }\n\n  .parameter,\n  .cardTitle,\n  .groupsHeader,\n  .ruleHeader,\n  .lineHeader {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `StructureMapVisualEditor_editor__-KCGJ`,
	"validation": `StructureMapVisualEditor_validation__4SImV`,
	"rootCard": `StructureMapVisualEditor_rootCard__KfwZh`,
	"groupCard": `StructureMapVisualEditor_groupCard__wSeKX`,
	"ruleCard": `StructureMapVisualEditor_ruleCard__-HuCQ`,
	"lineCard": `StructureMapVisualEditor_lineCard__aSvFl`,
	"groupsHeader": `StructureMapVisualEditor_groupsHeader__N2YG4`,
	"cardTitle": `StructureMapVisualEditor_cardTitle__n7BlC`,
	"ruleHeader": `StructureMapVisualEditor_ruleHeader__ALYeF`,
	"lineHeader": `StructureMapVisualEditor_lineHeader__M2fZb`,
	"parameter": `StructureMapVisualEditor_parameter__8DFMi`,
	"importLine": `StructureMapVisualEditor_importLine__JbF-a`,
	"field": `StructureMapVisualEditor_field__Bgo9I`,
	"sectionLabel": `StructureMapVisualEditor_sectionLabel__AbQkc`,
	"compactRow": `StructureMapVisualEditor_compactRow__whrKx`,
	"deleteColumn": `StructureMapVisualEditor_deleteColumn__IU4d9`,
	"parameterList": `StructureMapVisualEditor_parameterList__3sNiW`,
	"imports": `StructureMapVisualEditor_imports__+VGVk`,
	"form-control": `StructureMapVisualEditor_form-control__YJw2r`
};
export default ___CSS_LOADER_EXPORT___;
